export default __webpack_public_path__ + "static/media/set2.0ba9aff9.jpeg";